import "./styles.css";
import $ from "jquery";
import "jquery.easing";

const buttons = [
{
	left: "25",
	top: "70",
	left_large: "56",
	top_large: "50",
	name: "Creach",
	title: "Visite du Musée des Phares et Balises",
	info:
	"Marie-France nous guidera bientôt dans l'ambiance tamisée du Musée des Phares et Balises...",
	gps: "48.45921523405101, -5.128985126727841"
},
{
	left: "56",
	top: "75",
	left_large: "74",
	top_large: "56",
	name: "Niou",
	title: "Rencontre avec Marieno",
	info: "Marieno nous parlera bientôt d’elle et d’Ouessant...",
	gps: "48.45661960282496, -5.079223281688039"
},
{
	left: "45",
	top: "65",
	left_large: "67",
	top_large: "42",
	name: "CEMO",
	title: "Rencontre avec Fanch",
	info: "Fanch nous parlera bientôt de la faune et la flore d’Ouessant...",
	gps: "48.45686835462082, -5.12319752052593"
},
{
	left: "18",
	top: "80",
	left_large: "52",
	top_large: "64",
	name: "Pern",
	title: "Rencontre avec Titi",
	info: "Titi nous parlera bientôt de lui et de son enfance au Créac’h...",
	gps: "48.448954240158365, -5.14012923560047"
},
{
	left: "47",
	top: "32",
	left_large: "30",
	top_large: "48",
	name: "PetB",
	title: "Rencontre avec Michel",
	info: "Michel nous parlera bientôt de lui et des Phares & Balises...",
	gps: "48.37862525395073, -4.485478965342128"
},
{
	left: "18",
	top: "15",
	left_large: "20",
	top_large: "28",
	name: "chateau",
	title: "Visite du Musée de la Marine",
	info:
	"Mireille nous guide à travers le château et l’histoire de Brest, en commencent par le romains, puis les mâchicoulis, des bateaux de 2000 arbres, le pont tournant et ses milliers de tonnes de bombes.",
	audio: "http://oufipo.org/IMG/mp3/RPO/RPO_museeMarine_export.mp3",
	gps: "48.381931824095275, -4.493279312397416",
	photos: [
	"http://oufipo.org/IMG/jpg/RPO/RPO_museeMarine1.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_museeMarine2.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_museeMarine3.jpg"
	]
},
{
	left: "48",
	top: "24",
	left_large: "30",
	top_large: "38",
	name: "BerDomRem",
	title: "Visite du Skeaf",
	info:
	"Géraldine nous fait monter à bord du voilier de plaisance « Skeaf ». Elle nous parle de dauphins, de sirènes, de foc et de clin foc – mais aussi de voile sociale.",
	audio: "http://oufipo.org/IMG/mp3/RPO/RPO_visiteSkeaf_export.mp3",
	gps: "48.380373125221375, -4.486795910527962",
	photos: [
	"http://oufipo.org/IMG/jpg/RPO/RPO_skeaf1.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_skeaf2.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_skeaf3.jpg"
	]
},
{
	left: "34",
	top: "18",
	left_large: "24",
	top_large: "34",
	name: "SHD",
	title: "Visite du Service Historique de la Défense",
	info:
	"Laurent nous guide dans les arcanes du Service Historique de la Défense : une bibliothèque un peu spéciale où on rencontre La Pérouse, Vidocq et le calendrier républicain.",
	audio: "http://oufipo.org/IMG/mp3/RPO/RPO_visiteSHD_export.mp3",
	gps: "48.38140704295258, -4.488948032441889",
	photos: [
	"http://oufipo.org/IMG/jpg/RPO/RPO_shd1.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_shd2.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_shd3.jpg"
	]
},
{
	left: "16",
	top: "34",
	left_large: "20",
	top_large: "50",
	name: "encrier",
	title: "L’Académie de Marine",
	info:
	"Laurent nous ouvre les portes les mieux gardées du Service Historique de la Défense. Les trésors comprennent des gravures de la campagne d’Égypte, des aquarelles de Frezier, quelques incunables, et un ouvrage rarissime signé... Copernic.",
	audio: "http://oufipo.org/IMG/mp3/RPO/RPO_acadMarine_export.mp3",
	gps: "48.38140704295258, -4.488948032441889",
	photos: [
	"http://oufipo.org/IMG/jpg/RPO/RPO_acadMarine1.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_acadMarine2.jpg",
	"http://oufipo.org/IMG/jpg/RPO/RPO_acadMarine3.jpg"
	]
},
{
	left: "42",
	top: "13",
	left_large: "28",
	top_large: "26",
	name: "monument",
	title: "Rencontre avec Yffic",
	info:
	"Yffic nous parlera bientôt de lui et de sa vie sur le port. Car en plus d’y travailler, on y étendait du linge, on y parlait russe, on dansait sur les tables, et on surfait les tas de charbons.",
	gps: "48.382142896900504, -4.487118969704763"
}
];

const MAP_WIDTH_PORTRAIT = 800;
const MAP_WIDTH_LANDSCAPE = 2304;
const MAP_HEIGHT = 1080;
let MAP_ASPECTRATIO = MAP_WIDTH_PORTRAIT / MAP_HEIGHT;
const BREAKPOINT = 500;

let audio = new Audio(
	"http://oufipo.org/IMG/mp3/RPO/RPO_acadMarine_export.mp3"
	);

function initMap() {
	if (!isLargeScreen()) {
    // $("#header").offset({ top: 0 });
    $("#mapimg").attr(
    	"src",
    	"https://projets.larocade.com/cartesonore/RPO_carteSonore_portrait.jpg"
    	);
} else {
	$("#mapimg").attr(
		"src",
		"https://projets.larocade.com/cartesonore/RPO_carteSonore_landscape.jpg"
		);
}
}

function initButtons() {
	buttons.forEach((b) => {
		let l = 0,
		t = 0;
		if ($("#mapwrapper").width() >= BREAKPOINT) {
			l = b.left_large;
			t = b.top_large;
		} else {
			l = b.left;
			t = b.top;
		}

		$("#map").append(
			'<img id="' +
			b.name +
			'"class="pastille" src="https://projets.larocade.com/cartesonore/icons/RPO_logo_' +
			b.name +
			'.svg"' +
			' style="top: ' +
			t +
			"vh; left:" +
			l +
			'%" ' +
			"/>"
			);
	});

	$(".pastille").click(function () {
		const button = buttons.find((b) => b.name === this.id);
		showInfo(button);
	});

	$(".close").click(hideInfo);
}

function updateLayout() {
	if (!isLargeScreen()) {
    // screen small
    // $("#header").offset({ top: 0 });
    $("#mapimg").attr(
    	"src",
    	"https://projets.larocade.com/cartesonore/RPO_carteSonore_portrait.jpg"
    	);
} else {
    // screen large
    $("#mapimg").attr(
    	"src",
    	"https://projets.larocade.com/cartesonore/RPO_carteSonore_landscape.jpg"
    	);
}
$("#map").width($("#mapimg").width());

if (isLargeScreen()) MAP_ASPECTRATIO = MAP_WIDTH_LANDSCAPE / MAP_HEIGHT;
else MAP_ASPECTRATIO = MAP_WIDTH_PORTRAIT / MAP_HEIGHT;

let mapOffsetLeft =
(-MAP_ASPECTRATIO * $("#map").height()) / 2 + $("#mapwrapper").width() / 2;

$("#map").offset({
	left: mapOffsetLeft
});

if (isLargeScreen()) {
	$(".infobox").offset({
		left: -360
	});
} else {
	if ($("#mapwrapper").width() < $("#map").width())
		$(".infobox").width($("#mapwrapper").width() - 60);
	else $(".infobox").width($("#map").width() - 60);
	if ($("#mapwrapper").width() < $("#map").width())
		$(".infobox").offset({
			left: 0
		});
	else
		$(".infobox").offset({
			left: mapOffsetLeft
		});

	$(".infobox").css("bottom", -$(".infobox").innerHeight() + "px");

	$(".infobox").removeClass("active");
}

buttons.forEach((b) => {
	if (isLargeScreen())
		$("#" + b.name).css({
			left: b.left_large + "%",
			top: b.top_large + "vh"
		});
	else $("#" + b.name).css({ left: b.left + "%", top: b.top + "vh" });
});
}

function buildInfoHTML(but) {
	$(".infobox .titre").html(but.title);
	$(".infobox .info").html(but.info);
	$(".infobox .gps").html(
		"<a href='https://www.google.com/maps/place/" +
		but.gps +
		"' target='_blank'>" +
		but.gps +
		"</a>"
		);
	let photos_html = "";
	if (but.photos !== undefined) {
		but.photos.forEach((p) => {
			photos_html += "<img src='" + p + "' />";
		});
		if (isLargeScreen()) $(".photoswrapper").show();
	} else {
		$(".photoswrapper").hide();
	}
	$(".infobox .photos").html(photos_html);

	if (but.audio === undefined) $(".infobox .audio-player").hide();
	else $(".infobox .audio-player").show();

	$(".photos img").click(function (e) {
		var src = e.target.src;
		$("#modal-content").attr("src", src);
		$("#modal").css("display", "block");
	});
}

function showInfo(but) {
	if (!$(".infobox").hasClass("active")) {
		buildInfoHTML(but);

		if (isLargeScreen())
			$(".infobox").animate(
			{
				left: 0
			},
			2000,
			"easeOutBounce"
			);
		else {
			$(".infobox").animate(
			{
          // top: $("#header").outerHeight() + 5
          bottom: 0
      },
      2000,
      "easeOutBounce"
      );
			$(".infobox").offset({ bottom: -$(".infobox").outerHeight() + "px" });
		}
		$(".infobox").addClass("active");
	} else {
    // if already active
    if (isLargeScreen())
    	$(".infobox").animate(
    	{
    		left: -360
    	},
    	1000,
    	"easeInQuint",
    	function () {
          //on complete
          buildInfoHTML(but);
          $(".infobox").animate(
          {
          	left: 0
          },
          2000,
          "easeOutBounce"
          );
      }
      );
    else
    	$(".infobox").animate(
    	{
          // top: $("#header").innerHeight() - $(".infobox").innerHeight()
          bottom: -$(".infobox").innerHeight()
      },
      1000,
      "easeInQuint",
      function () {
          //on complete
          buildInfoHTML(but);
          $(".infobox").animate(
          {
              // top: $("#header").outerHeight() + 5
              bottom: 0
          },
          2000,
          "easeOutBounce"
          );
      }
      );
}

stopPlayer();
if (but.audio !== undefined) {
	audio = new Audio(but.audio);
    // setTimeout(() => {
    //   $("#currentTime").html(audio.duration);
    // }, 1000);
    audio.addEventListener("loadeddata", function () {
    	initProgressBar();
    	$("#currentTime").html(calculateCurrentValue(audio.duration));
    });
}
}

function hideInfo() {
	if (isLargeScreen())
		$(".infobox").animate(
		{
			left: -360
		},
		1000,
		"easeInQuint",
		function () {
			$(".infobox").removeClass("active");
			stopPlayer();
		}
		);
	else
		$(".infobox").animate(
		{
        // top: $("#header").innerHeight() - $(".infobox").innerHeight()
        bottom: -$(".infobox").innerHeight()
    },
    1000,
    "easeInQuint",
    function () {
    	$(".infobox").removeClass("active");
    	stopPlayer();
    }
    );
}

function isLargeScreen() {
	return $("#mapwrapper").width() >= BREAKPOINT;
}

function initModal() {
	$(".modal-close").click(function () {
		$("#modal").css("display", "none");
	});
}

// AUDIO PLAYER
function stopPlayer() {
	audio.pause();
	audio.currentTime = 0;
	$("#playAudio").removeClass("pause");
	audio.removeEventListener("timeupdate", initProgressBar);
}
function togglePlay() {
	if (audio.paused === false) {
		audio.pause();
		$("#playAudio").removeClass("pause");
		audio.removeEventListener("timeupdate", initProgressBar);
	} else {
		audio.play();
		$("#playAudio").addClass("pause");
		audio.addEventListener("timeupdate", initProgressBar);
	}
}
function calculatePercentPlayed() {
	let percentage = (audio.currentTime / audio.duration).toFixed(2) * 100;
	$("#percentage").width(percentage + "%");
}
function calculateCurrentValue(currentTime) {
	const currentMinute = parseInt(currentTime / 60, 10) % 60;
	const currentSecondsLong = currentTime % 60;
	const currentSeconds = currentSecondsLong.toFixed();
	let currentTimeFormatted = "";
	if (currentMinute < 10) currentTimeFormatted += "0" + currentMinute + ":";
	else currentTimeFormatted += currentMinute + ":";
	if (currentSeconds < 10) currentTimeFormatted += "0" + currentSeconds;
	else currentTimeFormatted += currentSeconds;

	return currentTimeFormatted;
}
function initProgressBar() {
	const currentTime = calculateCurrentValue(audio.currentTime);
	$("#currentTime").html(currentTime);
	$("#seekObj").click(seek);

	audio.onended = () => {
		$("#playAudio").removeClass("pause");
		$("#percentage").width(0);
		$("#currentTime").html("00:00");
	};

	function seek(e) {
		const percent = e.offsetX / $(this).width();
		audio.currentTime = percent * audio.duration;
	}

	calculatePercentPlayed();
}
// END AUDIO PLAYER

initMap();
$(function () {
  // on DOM READY
  initButtons();
  initProgressBar();
  initModal();
  $("#playAudio").click(togglePlay);

  $("#mapimg")
  .one("load", function () {
      // console.log("img loaded");
      $("#app").css("visibility", "visible");
      updateLayout();
  })
  .each(function () {
  	if (this.complete) {
  		$(this).trigger("load");
  	}
  });
});

$(window).on("resize", function () {
	updateLayout();
});
$(document).on("mouseup", function (e) {
	const inf = $(".infobox");
	const pas = $(".pastille");
	const mod = $("#modal");
	if (!inf.is(e.target) && inf.has(e.target).length === 0) {
		if (!pas.is(e.target) && pas.has(e.target).length === 0) {
			if (!mod.is(e.target) && mod.has(e.target).length === 0) {
				hideInfo();
			}
		}
	}
});
